import React from 'react';
import { Flex, Card } from "antd";
import { clrs } from "../../../constants/colors";
import MyText from "../../../components/UI/Text/MyText";
import IntlMessage from "../../../components/IntlMessage/IntlMessage";
import classes from './teamSection.module.css';
import userIcon from '../../../images/user-286.png';

const TeamSection = () => {
    const teamGroups = [
        {
            id: 1,
            titleKey: 'homePage.team.group1.title',
            members: [
                {
                    id: 1,
                    nameKey: 'homePage.team.group1.member1.name',
                    positionKey: 'homePage.team.group1.member1.position',
                    image: userIcon
                },
                {
                    id: 2,
                    nameKey: 'homePage.team.group1.member2.name',
                    positionKey: 'homePage.team.group1.member2.position',
                    image: userIcon
                },
                {
                    id: 3,
                    nameKey: 'homePage.team.group1.member3.name',
                    positionKey: 'homePage.team.group1.member3.position',
                    image: userIcon
                },
                {
                    id: 4,
                    nameKey: 'homePage.team.group1.member4.name',
                    positionKey: 'homePage.team.group1.member4.position',
                    image: userIcon
                },
                {
                    id: 5,
                    nameKey: 'homePage.team.group1.member5.name',
                    positionKey: 'homePage.team.group1.member5.position',
                    image: userIcon
                },
                {
                    id: 6,
                    nameKey: 'homePage.team.group1.member6.name',
                    positionKey: 'homePage.team.group1.member6.position',
                    image: userIcon
                },
                {
                    id: 7,
                    nameKey: 'homePage.team.group1.member7.name',
                    positionKey: 'homePage.team.group1.member7.position',
                    image: userIcon
                },
                {
                    id: 8,
                    nameKey: 'homePage.team.group1.member8.name',
                    positionKey: 'homePage.team.group1.member8.position',
                    image: userIcon
                }
            ]
        },
        {
            id: 2,
            titleKey: 'homePage.team.group2.title',
            members: [
                {
                    id: 1,
                    nameKey: 'homePage.team.group2.member1.name',
                    positionKey: 'homePage.team.group2.member1.position',
                    image: userIcon
                },
                {
                    id: 2,
                    nameKey: 'homePage.team.group2.member2.name',
                    positionKey: 'homePage.team.group2.member2.position',
                    image: userIcon
                },
                {
                    id: 3,
                    nameKey: 'homePage.team.group2.member3.name',
                    positionKey: 'homePage.team.group2.member3.position',
                    image: userIcon
                },
                {
                    id: 4,
                    nameKey: 'homePage.team.group2.member4.name',
                    positionKey: 'homePage.team.group2.member4.position',
                    image: userIcon
                }
            ]
        }
    ];

    const renderMemberCard = (member) => (
        <Card
            key={member.id}
            className={classes.memberCard}
            cover={
                <div className={classes.imageContainer}>
                    <img
                        alt={`Team member ${member.id}`}
                        src={member.image}
                        className={classes.memberImage}
                    />
                </div>
            }
            style={{
                borderRadius: "20px",
                overflow: "hidden",
                boxShadow: "0 8px 24px rgba(0, 0, 0, 0.1)",
                height: "520px"
            }}
        >
            <Flex vertical align={"center"} gap={15}>
                <MyText
                    style={{
                        fontSize: "1.4rem",
                        fontWeight: 700,
                        color: clrs.textColor,
                        textAlign: "center"
                    }}
                >
                    <IntlMessage id={member.nameKey} />
                </MyText>
                
                <MyText
                    style={{
                        fontSize: "1rem",
                        fontWeight: 400,
                        color: clrs.grey,
                        textAlign: "center"
                    }}
                >
                    <IntlMessage id={member.positionKey} />
                </MyText>
            </Flex>
        </Card>
    );

    return (
        <Flex
            style={{
                width: "100%",
                position: "relative",
                padding: "80px 20px",
                background: clrs.whiter3AquaGeo
            }}
            align={"center"}
            justify={"center"}
            vertical
        >
            <Flex
                gap={50}
                style={{ width: "100%", maxWidth: 1440, position: "relative" }}
                vertical
                align={"center"}
                justify={"flex-start"}
            >
                {/* Заголовок секции */}
                <Flex vertical align={"center"} gap={20} style={{ textAlign: "center", marginBottom: "40px" }}>
                    <MyText
                        style={{
                            fontSize: "2.5rem",
                            fontWeight: 900,
                            color: clrs.textColor,
                            textAlign: "center"
                        }}
                    >
                        <IntlMessage id={'homePage.team'} />
                    </MyText>
                    
                    <MyText
                        style={{
                            fontSize: "1.2rem",
                            fontWeight: 400,
                            color: clrs.textColor,
                            textAlign: "center",
                            maxWidth: "800px",
                            opacity: 0.8,
                            lineHeight: "1.6"
                        }}
                    >
                        <IntlMessage id={'homePage.team.description'} />
                    </MyText>
                </Flex>

                {/* Группы команд */}
                <Flex
                    style={{ width: "100%" }}
                    vertical
                    gap={60}
                    align={"center"}
                >
                    {teamGroups.map((group) => (
                        <Flex key={group.id} vertical gap={30} align={"center"} style={{ width: "100%" }}>
                            {/* Заголовок группы */}
                            <MyText
                                style={{
                                    fontSize: "2rem",
                                    fontWeight: 800,
                                    color: clrs.textColor,
                                    textAlign: "center"
                                }}
                            >
                                <IntlMessage id={group.titleKey} />
                            </MyText>
                            
                            {/* Карточки участников группы */}
                            <Flex
                                style={{ width: "100%" }}
                                wrap
                                gap={40}
                                justify={"center"}
                                align={"flex-start"}
                            >
                                {group.members.map(renderMemberCard)}
                            </Flex>
                        </Flex>
                    ))}
                </Flex>
            </Flex>
        </Flex>
    );
};

export default TeamSection; 